import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useInvoice(establishmentId, invoiceId) {
    const queryReturnValues = useQuery(
        ["invoice", { establishmentId, invoiceId }],
        inventoryClient.getInvoiceById,
        {
            staleTime: 1000 * 60 * 10
        }
    );

   return queryReturnValues;
}

export default useInvoice;